
import Vue from "vue";

export default Vue.extend({
  props: {
    isOnline: {
      type: Boolean,
      default: false,
    },
  },
});
